import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {Cookies} from '../../helpers/Cookies';
import {Observable, of} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import storage from 'store';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class UserService {

    constructor(
      private api: ApiService,
      private http: HttpClient
    ) {}

    public login(data): Observable<any> {
        Cookies.set('token', '', -1);
        return this.api.post('/login', data);
    }

    public requestPasswordReset(data: {email: string}): Observable<any> {
      return this.api.post('/login/restore-password-v2', {body: data});
    }

    public login_by_token(data): Observable<any> {
      Cookies.set('token', '', -1);
      return this.api.post('/login_by_token', data);
    }

    public validate_2fa(data): Observable<any> {
      Cookies.set('token', '', -1);
      return this.api.post('/login/validate-2fa', data);
    }

    public changePassword(body) {
      return this.api.put(`/passwords/change`, {
        body
      });
    }

    public logout(): Observable<any> {
        return this.api.post('/logout', {});
    }

    public modelInfo(): Observable<any> {
      return this.api.get('/login/model-info', {})
    }

    public groupFieldsInfo(): Observable<any> {
      return this.api.get('/login/group-fields-info', {});
    }

    public requestRestorePassword(body): Observable<any> {
      return this.api.post('/login/restore-password', {
        body
      });
    }

    public isAuthenticated(): boolean {
      return Cookies.get('token') && storage.get('user');
    }

    public getUsers(): Observable<any> {
        return this.api.get('/users', {});
    }

    public ip(): Observable<any> {
        try {
            const ipDetails = JSON.parse(sessionStorage.getItem('ip_details') || 'null');

            if(ipDetails) {
                return of(ipDetails)
            }
        } catch(e){}

        const ip = Cookies.get('cve_ip') || '93.175.202.243';

        return this.http.get('https://ip-validation.canadianvisa.org/ip-info?ip=' + ip, {
          headers: {
            Authorization: 'Bearer ' + environment.ipInfoBearer
          }
        }).pipe(
            tap((r) => {
                try {
                    sessionStorage.setItem('ip_details', JSON.stringify(r))
                } catch(e) {}
            })
        );
    }

    public unblock(id): Observable<any> {
      return  this.api.post(`/users/${id}`, {});
    }

    public agent_login(data): Observable<any> {
      return this.api.post('/agent_login', data);
    }

    public getUsersForLogin(param): Observable<any> {
      return this.api.get('/agent_login', {
        params: param
      });
    }

    public getManagerLoginData(managerId, userId): Observable<any> {
      return this.api.get('/agent_login/login-back/' + managerId + '/' + userId, {});
    }

    public getAvatar(crm_id): string {
        if (crm_id === undefined) {
            return '';
        }

        const baseUrl = 'https://d1ac9zce9817ms.cloudfront.net/images/icons';

        const number = parseInt(String(String(crm_id).split('').map(s => s.charCodeAt(0)).reduce((a, b) => a + b, 0) % 15), 10);

        return baseUrl + String(number) + '.svg';

    }

    public requestQrCode(userId): Observable<any> {
      return this.api.post('/login/' + userId + '/request-qr-code', {});
    }


    // PIP / PR
  public getAgents(params): Observable<any> {
    return this.api.get('/pip_pr/agents', {params});
  }

  public getUser(hash: string): Observable<any> {
    return this.api.get(`/pip_pr/agents/${hash}`, {});
  }

  public getDocuments(hash: string, params): Observable<any> {
    return this.api.get(`/pip_pr/folders/${hash}`, {params});
  }

  public getFavoriteDocuments(hash: string, params): Observable<any> {
    return this.api.get(`/pip_pr/favorites/${hash}`, {params});
  }

  public markAsFavorite(body): Observable<any> {
    return this.api.post(`/pip_pr/add-favorite`, {body});
  }

  public unmarkFavorite(body): Observable<any> {
    return this.api.post(`/pip_pr/delete-favorite`, {body});
  }

  public uploadFile(body: FormData, sign, type): Observable<any> {
    return this.api.post(`/pip_pr/upload/${type}/${sign}`, {body});
  }

  public downloadFile(fileId: string): Observable<any> {
    return this.api.get(`/document/download/${fileId}`, {});
  }

  public getEntitySharedTo(entity: 'folders' | 'documents', entity_id: string | number): Observable<any> {
    return this.api.get(`/pip_pr/folders/shared_users/${entity}/${entity_id}`, {});
  }

  public shareEntityTo(body: any, entity: 'folders' | 'documents', entity_id: string | number): Observable<any> {
    return this.api.post(`/pip_pr/folders/share/${entity}/${entity_id}`, {body});
  }

  public getTemplates(params: any): Observable<any> {
    return this.api.get(`/pip_pr/all-templates`, {params});
  }

  public deleteFile(folder, file): Observable<any> {
    return this.api.delete(`/pip_pr/pip-pdf/${folder}/${file}`, {});
  }

  public moveFile(folder, file, body): Observable<any> {
    return this.api.post(`/pip_pr/pip-pdf/move/${folder}/${file}`, {body});
  }

  public moveFolder(body): Observable<any> {
    return this.api.post(`/pip_pr/folders/move`, {body});
  }

  public editFile(file, body): Observable<any> {
    return this.api.put(`/pip_pr/pip-pdf/${file}`, {body});
  }

  public generatePdf(body): Observable<any> {
    return this.api.post('/pip_pr/pip-pdf', {body});
  }

  public savePdf(save, preview, body): Observable<any> {
    return this.api.post(`/pip_pr/pip-pdf/save/${save}/${preview}`, {body});
  }

  public savePdfMultiple(save, body): Observable<any> {
    return this.api.post(`/pip_pr/pip-pdf/multiple_save/${save}`, {body});
  }

  // Declaration of Transaction doc
  public generatePdfDoc(body: {type: string, template_id?: number, html?: string, payment_id?: string, params?: any, }): Observable<any> {
    return this.api.post('/document/generate-doc/v2' , {body});
  }

  public saveDocument(body: FormData): Observable<any> {
    return this.api.post(`/document/upload`, {body});
  } 

  // Folders
  public deleteFolder(folder: number): Observable<any> {
    return this.api.delete(`/pip_pr/folders/${folder}`, {});
  }

  public editFolder(folder: number, body: any): Observable<any> {
    return this.api.put(`/pip_pr/folders/${folder}`, {body});
  }

  public getFoldersList(hash: string): Observable<any> {
    return this.api.get(`/pip_pr/all-folders/${hash}`, {});
  }

  public createFolder(hash: string, body: any): Observable<any> {
    return this.api.post(`/pip_pr/folders/${hash}`, {body});
  }


  public addComment(document_id: number, body): Observable<any> {
    return this.api.post(`/comments/documents/${document_id}`, {body});
  }

  public getComment(document_id: number, params): Observable<any> {
    return this.api.get(`/comments/documents/${document_id}/documents`, {params});
  }


}
